// extracted by mini-css-extract-plugin
module.exports = {"verifiedOld":"verified-badge_verifiedOld__EjcKt","verifiedBlue":"verified-badge_verifiedBlue__HAAMZ","verifiedGovernment":"verified-badge_verifiedGovernment__CxwxK"};